import ListItem from './ListItem'
import classNames from 'classnames'
import {useMemo} from 'react'
import './index.scss'
import {useNamespaceTranslations} from '../../../../utils/hooks/useNamespacesTranslations'
import {resolveMetricType} from '../../../../utils/rulesetMetrics'

const ListView = ({
    data,
    isDarkMode,
    showEditModal,
    onDeleteClick,
    highlightedMetricKeys
}) => {
    const text = useNamespaceTranslations('rulesets')
    const orderedData = useMemo(() => {
        const items = data ?? []

        return items
            .map(item => ({item, isHighlighted: !!highlightedMetricKeys?.includes(resolveMetricType(item))}))
            .sort((a, b) => Number(b.isHighlighted) - Number(a.isHighlighted))
    }, [data, highlightedMetricKeys])

    return (
        <div
            className={classNames('ruleset-grid', {
                dark: isDarkMode
            })}
        >
            <div
                className={classNames('ruleset-list', {
                    dark: isDarkMode
                })}
            >
                <div
                    className={classNames('ruleset-group', {
                        dark: isDarkMode
                    })}
                >
                    <div className="ruleset-group-header">
                        <div className="ruleset-group-title">
                            <h3 className="ruleset-metric-title">
                                {text.metric}
                            </h3>
                        </div>
                        <div className='ruleset-group-header-list'>
                            <div className="header-row">
                                <span className="title">{text.urgency}</span>
                            </div>
                            <div className="header-row">
                                <span className="title">{text.status}</span>
                            </div>
                            <div className="header-row">
                                <span className="title">{text.updated_at}</span>
                            </div>
                            <div className="header-row actions w-0">
                            </div>
                        </div>
                    </div>
                    {orderedData.map(({item, isHighlighted}, index) => (
                        <ListItem
                            key={item?.id ?? index}
                            item={item}
                            isDarkMode={isDarkMode}
                            showEditModal={(item) => showEditModal(item)}
                            onDeleteClick={onDeleteClick}
                            isHighlighted={isHighlighted}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default ListView